import taiwanId from '@/utils/taiwanId';

/**
 * 會員基本資料
 * @returns {Object}
 */
const state = () => ({
    address: null,
    id: null,
    birthday: null,
    name: null,
    mobile: null,
    email: null,
    county: null,
    district: null,
    zipCode: null,
});

const actions = {};

const getters = {
    /**
     * 判斷身份是否為外籍人士
     * @param {*} state
     * @returns {Boolean}
     */
    isForeigner: (state) => {
        return taiwanId.isResidenceCertificateNumberValid(state.id);
    },
};

/**
 * 設定資料狀態
 */
const mutations = {
    /**
     * 地址
     * @param {*} state
     * @param {*} payload
     */
    setAddress(state, payload) {
        state.address = payload;
    },
    /**
     * 國籍
     * @param {*} state
     * @param {*} payload
     */
    setCounty(state, payload) {
        state.county = payload;
    },
    /**
     * 居住地址-縣市
     * @param {*} state
     * @param {*} payload
     */
    setDistrict(state, payload) {
        state.district = payload;
    },
    /**
     * 身分證字號/居留證/統一編號
     * @param {*} state
     * @param {*} payload
     */
    setId(state, payload) {
        state.id = payload;
    },
    /**
     * 出生日期
     * @param {*} state
     * @param {*} payload
     */
    setBirthday(state, payload) {
        state.birthday = payload;
    },
    /**
     * 姓名
     * @param {*} state
     * @param {*} payload
     */
    setName(state, payload) {
        state.name = payload;
    },
    /**
     * 手機號碼
     * @param {*} state
     * @param {*} payload
     */
    setMobile(state, payload) {
        state.mobile = payload;
    },
    /**
     * Email
     * @param {*} state
     * @param {*} payload
     */
    setEmail(state, payload) {
        state.email = payload;
    },
    /**
     * 地址
     * @param {*} state
     * @param {*} payload
     */
    setZipCode(state, payload) {
        state.zipCode = payload;
    },
    /**
     * 清除資料內容
     * @param {*} state
     */
    clear(state) {
        state.id = null;
        state.birthday = null;
        state.name = null;
        state.mobile = null;
        state.email = null;
        state.address = null;
        state.county = null;
        state.district = null;
        state.zipCode = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
